<template>
  <div>
    <b-collapse
      class="card show"
      animation="slide"
      v-for="(collapse, index) of collapses"
      :key="index"
      :open="isOpen == index"
      @open="isOpen = index"
      :aria-id="'contentIdForA11y5-' + index"
    >
      <template #trigger="props">
        <div
          class="card-header"
          role="button"
          :aria-controls="'contentIdForA11y5-' + index"
          :aria-expanded="props.open"
        >
          <p class="card-header-title">
            {{ collapse.title }}
          </p>
          <a class="card-header-icon">
            <b-icon :icon="props.open ? 'menu-down' : 'menu-up'"> </b-icon>
          </a>
        </div>
      </template>
      <div class="card-content">
        <div class="content">
          <div v-if="collapse.id === 0" class="columns column is-full">
            <b-field class="column is-full" label="Upload excel data">
              <input type="file" @change="onUniversityFileChange" />
            </b-field>

            <div class="column is-full">
              <b-button @click="downloadUniversityFile()" type="is-success">
                Download university excel
              </b-button>
              <b-button
                style="margin-left: 15px"
                @click="uploadUniversityFile()"
                type="is-success"
              >
                Upload bulk data
              </b-button>
            </div>
            <b-table :data="universities" :mobile-cards="true">
              <b-table-column field="title" label="Title" v-slot="props">
                {{ props.row.title }}
              </b-table-column>

              <b-table-column field="title" label="Address" v-slot="props">
                {{ props.row.address }}
              </b-table-column>

              <b-table-column field="logo" label="Logo" v-slot="props">
                <b-image
                  class="uni-logo"
                  v-if="props.row.img_url"
                  :src="props.row.img_url"
                  alt=""
                ></b-image>
              </b-table-column>

              <b-table-column
                field="title"
                label="Google docs URL"
                v-slot="props"
              >
                {{ props.row.docs_url }}
              </b-table-column>

              <template #empty>
                <div class="has-text-centered">No records</div>
              </template>
            </b-table>
          </div>

          <div v-if="collapse.id === 1" class="columns column is-full">
            <b-field class="column is-full" label="Upload excel data">
              <input type="file" @change="onCourseFileChange" />
            </b-field>

            <div class="column is-full">
              <b-button tag="a" :href="courseHref" type="is-success">
                Download courses excel
              </b-button>
              <b-button
                style="margin-left: 15px"
                @click="uploadCourseFile()"
                type="is-success"
              >
                Upload bulk data
              </b-button>
            </div>

            <b-table mobile-cards :data="courses">
              <b-table-column field="title" label="Course name" v-slot="props">
                {{ props.row.title }}
              </b-table-column>
              <b-table-column
                field="university.title"
                label="University"
                v-slot="props"
              >
                {{ props.row.university }}
              </b-table-column>
              <b-table-column
                field="documents"
                label="Required documents"
                v-slot="props"
              >
                {{ formatDocuments(props.row.templateOptions.documents) }}
              </b-table-column>

              <b-table-column
                field="standard_route"
                label="Standard route"
                v-slot="props"
              >
                {{ props.row.templateOptions.standard_route }}
              </b-table-column>

              <b-table-column
                field="timetable"
                label="Timetable"
                v-slot="props"
              >
                {{ props.row.templateOptions.timetable }}
              </b-table-column>

              <b-table-column field="deadline" label="Deadline" v-slot="props">
                {{ props.row.templateOptions.deadline }}
              </b-table-column>

              <b-table-column
                field="timetable_options"
                label="Timetable Options"
                v-slot="props"
              >
                {{
                  formatDocuments(props.row.templateOptions.timetable_options)
                }}
              </b-table-column>

              <b-table-column field="notes" label="Notes" v-slot="props">
                {{ props.row.templateOptions.notes }}
              </b-table-column>

              <b-table-column
                field="actions"
                label="Actions"
                v-slot="props"
                width="120"
              >
                <b-button
                  @click="deleteCourse(props.index)"
                  type="is-danger"
                  style="margin-right: 20px"
                  >Delete</b-button
                >
              </b-table-column>

              <template #empty>
                <div class="has-text-centered">No records</div>
              </template>
            </b-table>
          </div>

          <div v-if="collapse.id === 2" class="columns">
            <b-field class="column is-full" label="Upload excel data">
              <input type="file" @change="onPrevFileChange" />
            </b-field>

            <div class="column is-full">
              <b-button
                style="margin-left: 15px"
                @click="uploadPrevStudentFile()"
                type="is-success"
              >
                Upload bulk data
              </b-button>
            </div>

            <b-table
              class="column is-full scroll-table"
              v-if="prevStudents.length"
              :data="prevStudents"
            >
              <b-table-column field="title" label="Student name" v-slot="props">
                {{ props.row.first_name + props.row.last_name }}
              </b-table-column>
              <b-table-column
                field="studentId"
                label="Student ID"
                v-slot="props"
              >
                {{ props.row.studentId }}
              </b-table-column>
              <b-table-column
                field="documents"
                label="Phone number"
                v-slot="props"
              >
                {{ props.row.phone_number }}
              </b-table-column>

              <b-table-column
                field="standard_route"
                label="Email"
                v-slot="props"
              >
                {{ props.row.email }}
              </b-table-column>

              <b-table-column
                field="standard_route"
                label="Delivery"
                v-slot="props"
              >
                {{ props.row.delivery }}
              </b-table-column>

              <b-table-column
                field="standard_route"
                label="Agent"
                v-slot="props"
              >
                {{ props.row.agent }}
                <b-icon
                  :icon="props.row.moderatorId ? 'check' : 'cancel'"
                  :type="props.row.moderatorId ? 'is-success' : 'is-danger'"
                ></b-icon>
              </b-table-column>

              <b-table-column
                field="standard_route"
                label="Booking"
                v-slot="props"
              >
                {{ props.row.booking }}
              </b-table-column>

              <b-table-column
                field="standard_route"
                label="Interview"
                v-slot="props"
              >
                {{ props.row.interview }}
              </b-table-column>

              <b-table-column
                field="standard_route"
                label="English Test"
                v-slot="props"
              >
                {{ props.row.english_test }}
              </b-table-column>

              <b-table-column
                field="standard_route"
                label="status"
                v-slot="props"
              >
                {{ props.row.status }}
              </b-table-column>
              <b-table-column
                field="standard_route"
                label="Comments"
                v-slot="props"
              >
                {{ props.row.comments }}
              </b-table-column>

              <b-table-column
                field="standard_route"
                label="intake"
                v-slot="props"
              >
                {{ props.row.intake }}
              </b-table-column>

              <template #empty>
                <div class="has-text-centered">No records</div>
              </template>
            </b-table>
          </div>
        </div>
      </div>
    </b-collapse>
  </div>
</template>

<script>
import UtilService from '../../services/util';
import * as XLSX from 'xlsx/xlsx';
import AdminService from '../../services/admin.service';
import StudentService from '../../services/student.service';
import { deadlineCoursesDates } from '../../models/static';

export default {
  name: 'excel-upload',
  data() {
    return {
      universities: [],
      courseUniversities: [],
      courses: [],
      prevStudents: [],
      courseHref: process.env.VUE_APP_BASE_URL + '/api/admin/generateExcel',
      isOpen: 1,
      collapses: [
        {
          title: 'University upload',
          id: 0,
        },
        {
          title: 'Courses upload',
          id: 1,
        },
        {
          title: 'Previous students upload',
          id: 2,
        },
      ],
    };
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
    isManagement() {
      return UtilService.isManagement();
    },
  },
  methods: {
    onUniversityFileChange(event) {
      const file = event.target.files ? event.target.files[0] : null;
      if (file) {
        const reader = new FileReader();

        reader.onload = (e) => {
          /* Parse data */
          const bstr = e.target.result;
          const wb = XLSX.read(bstr, {
            type: 'binary',
          });
          /* Get first worksheet */
          const wsname = wb.SheetNames[0];
          const ws = wb.Sheets[wsname];
          /* Convert array of arrays */
          let data = XLSX.utils.sheet_to_json(ws, {
            header: 1,
          });
          data.splice(0, 1);

          data.forEach((fieldType) => {
            this.universities.push({
              title: fieldType[0],
              img_url: fieldType[1],
              address: fieldType[2],
              docs_url: fieldType[3],
            });
          });
        };

        reader.readAsBinaryString(file);
      }
    },

    downloadUniversityFile() {
      const data = XLSX.utils.json_to_sheet([
        {
          title: '',
          img_url: '',
          address: '',
          docs_url: '',
        },
      ]);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, data, 'data');
      XLSX.writeFile(wb, 'Universities.xlsx');
    },

    onCourseFileChange(event) {
      const file = event.target.files ? event.target.files[0] : null;
      if (file) {
        const reader = new FileReader();

        reader.onload = (e) => {
          /* Parse data */
          const bstr = e.target.result;
          const wb = XLSX.read(bstr, {
            type: 'binary',
          });
          /* Get first worksheet */
          const wsname = wb.SheetNames[0];
          const ws = wb.Sheets[wsname];
          /* Convert array of arrays */
          let data = XLSX.utils.sheet_to_json(ws, {
            header: 1,
            raw: false,
          });

          const uniName = wb.SheetNames[1];
          const wsUni = wb.Sheets[uniName];

          const uniData = XLSX.utils.sheet_to_json(wsUni, {
            header: 1,
          });

          for (let index = 0; index < uniData.length; index++) {
            const uni = uniData[index];
            this.courseUniversities.push({
              id: uni[1],
              title: uni[0],
            });
          }

          data.splice(0, 1);

          data.forEach((fieldType, index) => {
            if (!fieldType[0]) {
              return;
            }

            let universityId;

            try {
              universityId = this.courseUniversities.filter(
                (university) => university.title === fieldType[1]
              )[0].id;
            } catch (error) {
              // eslint-disable-next-line no-console
              console.warn(index, fieldType[0], fieldType[1]);
            }

            this.courses.push({
              title: fieldType[0],
              universityId,
              university: fieldType[1],
              templateOptions: {
                standard_route: fieldType[2],
                timetable: fieldType[3],
                timetable_options:
                  fieldType[4] !== undefined ? fieldType[4].split(', ') : [],
                admission_process: fieldType[5],
                deadline: deadlineCoursesDates.includes(fieldType[6])
                  ? fieldType[6]
                  : JSON.stringify(fieldType[6]),
                documents:
                  fieldType[7] !== undefined ? fieldType[7].split(', ') : [],
                notes: fieldType[9],
              },
            });
          });
        };

        reader.readAsBinaryString(file);
      }
    },

    uploadUniversityFile() {
      AdminService.bulkCreateUniversities(this.universities).then(() => {
        this.universities = [];
        this.$buefy.toast.open({
          duration: 3000,
          message: `Succesfully added universities`,
          position: 'is-bottom',
          type: 'is-success',
        });
      });
    },

    onPrevFileChange(event) {
      const file = event.target.files ? event.target.files[0] : null;
      if (file) {
        const reader = new FileReader();

        reader.onload = (e) => {
          /* Parse data */
          const bstr = e.target.result;
          const wb = XLSX.read(bstr, {
            type: 'binary',
          });
          /* Get first worksheet */
          const wsname = wb.SheetNames[0];
          const ws = wb.Sheets[wsname];
          /* Convert array of arrays */
          let data = XLSX.utils.sheet_to_json(ws, {
            header: 1,
          });
          data.splice(0, 1);
          data.forEach((fieldType) => {
            if (fieldType.length) {
              this.prevStudents.push({
                first_name: fieldType[0].split(' ').slice(0, -1).join(' '),
                last_name: fieldType[0].split(' ').slice(-1).join(' '),
                studentId: fieldType[1],
                phone_number: fieldType[2],
                email: fieldType[3],
                delivery: fieldType[4],
                agent: fieldType[5],
                moderatorId: UtilService.getUserIdByUsername(fieldType[5]),
                booking: fieldType[6],
                interview: fieldType[8],
                english_test: fieldType[8],
                status: fieldType[9],
                comments: fieldType[10],
                intake: fieldType[11],
                courseId: fieldType[12],
              });
            }
          });
        };

        reader.readAsBinaryString(file);
      }
    },

    chunkArrayInGroups(arr, size) {
      var myArray = [];
      for (var i = 0; i < arr.length; i += size) {
        myArray.push(arr.slice(i, i + size));
      }
      return myArray;
    },

    uploadPrevStudentFile() {
      const prevStudents = this.prevStudents.map((student) => {
        return {
          isOldStudent: true,
          courseId: student.courseId,
          moderatorId: student.moderatorId,
          status: student.status,
          templateOptions: JSON.stringify({
            personalInformation: {
              title: '',
              first_name: student.first_name,
              last_name: student.last_name,
              date_of_birth: null,
              nationality: '',
              birth_country: '',
              phone_number: student.phone_number,
              email: student.email,
              email_copy: student.email,
              gender: null,
              married: null,
              country: '',
              zip_code: '',
              house_number: '',
              street_address: '',
              city: '',
              delivery_mode: student.delivery,
              timetable: '',
              intake: student.intake,
            },
            generalInfo: {
              booking: student.booking,
              interview: student.interview,
              english_test: student.english_test,
              voucher: '',
              comments: student.comments,
              studentId: student.studentId,
              student_finance: '',
            },
          }),
        };
      });

      // if (prevStudents.length > 100) {
      const newCourse = this.chunkArrayInGroups(prevStudents, 10);
      for (let index = 0; index < newCourse.length; index++) {
        const element = newCourse[index];
        StudentService.createOldStudent(element).then(() => {
          this.prevStudents = [];
          this.$buefy.toast.open({
            duration: 3000,
            message: `Succesfully added previous students`,
            position: 'is-bottom',
            type: 'is-success',
          });
        });
      }
      // }
    },

    uploadCourseFile() {
      const courses = this.courses.map((course) => {
        return {
          title: course.title,
          universityId: course.universityId,
          templateOptions: JSON.stringify(course.templateOptions),
        };
      });

      if (courses.length > 100) {
        const newCourse = this.chunkArrayInGroups(courses, 10);
        for (let index = 0; index < newCourse.length; index++) {
          const element = newCourse[index];
          AdminService.bulkCreateCourses(element).then(() => {
            this.courses = [];
            this.$buefy.toast.open({
              duration: 3000,
              message: `Succesfully added courses`,
              position: 'is-bottom',
              type: 'is-success',
            });
          });
        }
      }
    },

    formatDocuments(documents) {
      return documents.join(', ');
    },

    deleteCourse(index) {
      this.courses.splice(index, 1);
    },
  },
};
</script>

<style>
.uni-logo {
  max-width: 80px;
}

.scroll-table {
  max-width: 100vw;
  max-height: 50vh;
  overflow: scroll;
}
</style>
